export default __webpack_public_path__ + "static/media/ballons.9003915c.svg";